import React from 'react';
import PropTypes from 'prop-types';

import { formatPrice } from 'utils/price';

const BookingTotal = ({ total }) => {
  return (
    <div className="booking-total">
      <div className="booking-total__label">Booking Total</div>
      <div className="booking-total__price" data-cy="bookingTotal">
        {formatPrice(total)}
      </div>
    </div>
  );
};

BookingTotal.propTypes = {
  total: PropTypes.number,
};

BookingTotal.defaultProps = {
  total: 0.0,
};

export default BookingTotal;
